// extracted by mini-css-extract-plugin
module.exports = {"root":"ToxicityLabel-root-ce26a135ac5460c62648e05600383ccf","likely":"ToxicityLabel-likely-f4d723c5f1edb0b6b9bf696f99d5ba80"};